module.exports = __webpack_public_path__ + "img/临床监察员.6c0cbed1.jpg";